export interface IFeatureManagement {
  googleSearchButton: boolean;
}

export default class FeatureManagement implements IFeatureManagement {
  public googleSearchButton: boolean = false;

  constructor(args?: Partial<IFeatureManagement>) {
    if (args) {
      Object.assign(this, { googleSearchButton: false }, args);
    }
  }

  /**
   * Deserialize an object to create a FeatureManagement instance.
   * @param input
   * @returns
   */
  static deserialize(input: Object): FeatureManagement {
    return new FeatureManagement(input as Partial<IFeatureManagement>);
  }

  /**
   * Get the keys of the FeatureManagement instance.
   * @returns Array of feature flag keys.
   */
  static getKeys(instance?: FeatureManagement): Array<keyof FeatureManagement> {
    instance ??= new FeatureManagement();
    return Object.keys(instance) as Array<keyof FeatureManagement>;
  }
}
